import engine from 'store/src/store-engine'
import sessionStorage from 'store/storages/sessionStorage'

export default () => {
  if (typeof window === `undefined`) return null
  return engine.createStore(sessionStorage)
}
